<template>
    <div class="ado-kiosk__dashboard row justify-content-center align-items-center" @click="setFocus()">
        <div class="ado-kiosk__filter"></div>
        <div class="col-10 col-sm-6 col-md-4 p-0">
            <div class="ado-kiosk__card card">
                <div v-if="getOpenStatus()" class="card-body">
                    <div v-if="!checkInStatus" class="ado-kiosk__signin">
                        <div class="ado-kiosk__title">ADO Check-In</div>
                        <div class="ado-kiosk__logo"><img src="../../assets/logo/logo.jpg"></div>
                        <div v-if="status.showWeekdayMessage == '1'" class="alert alert-primary" role="alert">
                            <p class="mb-0">{{ status.weekdayMessage }}</p>
                        </div>
                        <div v-if="kioskAlertStatus" class="ado-kiosk__alert">
                            <div :class="setAlertText()">
                                <i class="far fa-exclamation-circle"></i> {{ kioskAlertMessage }}
                            </div>
                        </div>
                        <div class="ado-kiosk__credentials">
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="studentNumber"><i class="far fa-user"></i></span>
                                </div>
                                <input type="text" class="form-control" id="studentNumber" name="studentNumber"
                                    ref="studentNumber" v-model="studentNumber" placeholder="Enter Student Number"
                                    aria-label="Student Number" @input="updateStudentNumber()"
                                    @keydown.enter="checkInStudentNumber()" aria-describedby="studentNumber">
                            </div>
                        </div>
                        <div class="ado-kiosk__menu">
                            <button type="button" class="btn btn-primary mr-3" @click="checkInStudentNumber()"><i
                                    class="far fa-user-check"></i> Check In</button>
                            <button type="button" class="btn btn-danger" @click="clearStudentNumber()"><i
                                    class="far fa-backspace"></i> Clear</button>
                        </div>
                    </div>
                    <div v-else class="ado-kiosk__checkin">
                        <div class="ado-kiosk__title">ADO Check-In</div>
                        <div class="ado-kiosk__checkin-message">
                            {{ checkInMessage }}
                        </div>
                        <div class="ado-kiosk__checkin-icon">
                            <i v-if="checkInType == 'success'" class="far fa-check fa-3x"></i>
                            <i v-else-if="checkInType == 'warning'" class="far fa-bells fa-3x text-warning"></i>
                            <i v-else-if="checkInType == 'danger'"
                                class="far fa-exclamation-circle fa-3x text-danger"></i>
                            <i v-else class="fas fa-spinner fa-spin fa-3x"></i>
                        </div>
                    </div>
                </div>
                <div v-else class="card-body">
                    <div class="ado-kiosk__title">ADO Check-In</div>
                    <div class="ado-kiosk__logo"><img src="../../assets/logo/logo.jpg"></div>
                    <div v-if="status.showWeekdayMessage == '1'" class="alert alert-primary" role="alert">
                        <p class="mb-0">{{ status.weekdayMessage }}</p>
                    </div>
                    <div class="alert alert-warning" role="alert">
                        <h5 class="alert-heading">{{ getClosureType }}</h5>
                        <span v-if="status.closureType.type == 'kiosk' && status.showCheckinMessage == '1'">
                            <hr>
                            <p class="mb-0">{{ status.checkinMessage }}</p>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    setTimeout
} from 'timers';

export default {
    name: 'ado-kiosk',
    data() {
        return {
            checkInMessage: '',
            checkInStatus: false,
            checkInType: '',
            kioskAlert: '',
            kioskAlertMessage: '',
            kioskAlertStatus: false,
            kioskAlertType: '',
            rawID: '',
            refreshCycle: '',
            status: {
                checkinMessage: '',
                checkinMethodType: '',
                closed: 0,
                closureType: {
                    type: '',
                    typeMessage: '',
                    typeMessageShow: 0
                },
                showCheckinMessage: 0,
                showWeekdayMessage: 0,
                weekday: '',
                weekdayMessage: ''
            },
            studentNumber: ''
        }
    },
    methods: {
        checkInStudentNumber() {
            const that = this;
            const rawID = this.rawID;
            const studentNumber = this.studentNumber;
            const api = `https://${location.hostname}/cgi-bin/mkvn-cardservices-backend/controller.cardservices.pl?signin`;
            const formData = new FormData();

            // Add form keypair values
            formData.append('id', studentNumber);
            formData.append('rawID', rawID);

            // Student number validation
            if (studentNumber.length < 9) {
                // Error message
                this.kioskAlertMessage = 'Please enter a valid Student Number.';
                this.kioskAlertStatus = true;

                // Set alert timeout
                if (!this.kioskAlert) {
                    that.kioskAlert = setTimeout(function () {
                        that.kioskAlertStatus = false;
                        that.kioskAlert = '';
                    }, 2500);
                }
            } else {
                // Remove error message
                this.kioskAlertStatus = false;
                this.kioskAlertMessage = '';

                // Set check-in message
                this.checkInMessage = 'Checking in...';
                this.checkInType = '';
                this.checkInStatus = true;

                // GET request
                fetch(api, {
                        method: 'POST',
                        body: formData
                    })
                    .then(function (response) {
                        // Return response
                        return response.json();
                    })
                    .then(function (json) {
                        // Success
                        if (json.result.match(/success/i)) {
                            // Set check-in message
                            that.checkInType = 'success';
                            that.checkInMessage = 'Please proceed to the waiting area at the top of the ramp, your name will be called in sequence.';
                        } else if (json.result.match(/queue/i)) {
                            // Set in-queue message
                            that.checkInType = 'warning';
                            that.checkInMessage = 'It looks like you have already checked in! Please proceed to the waiting area at the top of the ramp, your name will be called in sequence.';
                        } else {
                            // Set fail message
                            that.checkInType = 'danger';
                            that.checkInMessage = 'We are unable to check you in. Please proceed to the front desk for assistance.';
                        }

                        // Clear student number
                        that.clearStudentNumber();
                    })
                    .catch(function () {
                        // Set fail message
                        that.checkInType = 'danger';
                        that.checkInMessage = 'We are unable to check you in. Please proceed to the front desk for assistance.';

                        // Clear student number
                        that.clearStudentNumber();
                    })

                // Remove alert
                setTimeout(function () {
                    // Remove message
                    that.checkInStatus = false;
                    that.checkInType = '';
                    that.checkInMessage = '';

                    // Reset focus
                    setTimeout(function () {
                        that.setFocus();
                    }, 500);
                }, 5000);
            }
        },
        clearStudentNumber() {
            // Clear student number
            this.studentNumber = '';
        },
        getOpenStatus() {
            let bool = true;

            // Check manual shutdown
            if (this.status && this.status.closed == 1) {
                bool = false;
            }

            return bool;
        },
        getSystemSettings() {
            const that = this;
            const api = `https://${location.hostname}/cgi-bin/mkvn-cardservices-backend/controller.cardservices.pl?statusKiosk`;

            // GET request
            fetch(api)
                .then(function (response) {
                    return response.json();
                })
                .then(function (json) {
                    console.log(json);
                    // Set system settings
                    that.status.checkinMessage = json.checkinMessage ? json.checkinMessage : that.status.checkinMessage;
                    that.status.checkinMethodType = json.checkinMethodType ? json.checkinMethodType : that.status.checkinMethodType;
                    that.status.closed = json.closed ? json.closed : that.status.closed;
                    that.status.closureType = json.closureType ? json.closureType : that.status.closureType;
                    that.status.showCheckinMessage = json.showCheckinMessage ? json.showCheckinMessage : that.status.showCheckinMessage;
                    that.status.showWeekdayMessage = json.showWeekdayMessage ? json.showWeekdayMessage : that.status.showWeekdayMessage;
                    that.status.weekday = json.weekday ? json.weekday : that.status.weekday;
                    that.status.weekdayMessage = json.weekdayMessage ? json.weekdayMessage : that.status.weekdayMessage;
                })
                .catch(function (error) {
                    console.log(error);
                })
        },
        setAlertText() {
            // Return alert text class
            return {
                'text-success': this.kioskAlertType == 'success',
                'text-warning': this.kioskAlertType.match(/warning/i),
                'text-danger': this.kioskAlertType.match(/danger/i) || this.kioskAlertType == ''
            }
        },
        setFocus() {
            // Set form focus
            if (this.$refs.studentNumber) {
                this.$refs.studentNumber.focus();
            }
        },
        updateStudentNumber() {
            const that = this;
            let ref = this.$refs.studentNumber;
            let scan = ref.value.match(/\d{9}\?/);
            let value = ref.value;

            // Store raw ID
            this.rawID = ref.value;

            // Remove all non-digit characters and limit input to 9 digits
            value = value.replace(/\D/gi, '');
            value = value.match(/^\d{0,9}/);

            // Update student number
            this.studentNumber = value[0];

            // Process time
            if (scan) {
                setTimeout(function () {
                    // Auto check-in if student card is scanned
                    that.checkInStudentNumber();
                }, 1000);
            }
        }
    },
    computed: {
        getClosureType() {
            if (this.status.closureType && this.status.closureType.type && this.status.closureType.type.match(/hours of operation/gi)) {
                return `Check-in is closed! We are sorry but our office is currently closed for appointments.`;
            } else if (this.status.closureType && this.status.closureType.type && this.status.closureType.type.match(/capacity/gi)) {
                return `Check-in capacity has been reached for today, but you will still be able to see a counsellor during this drop-in period. Please be patient and remain in the queue. Note that you will no longer be able to access the drop-in dashboard. You will receive an email informing you when the counsellor is ready to see you. Thank you for your patience as we proceed through this busy time. `;
            }

            return `Check-in is closed!`;
        },
    },
    mounted() {
        // Onload focus
        this.setFocus();
    },
    created() {
        const that = this;

        // Retrieve database
        this.getSystemSettings();

        // Auto refresh
        this.refreshCycle = setInterval(function () {
            that.getSystemSettings();
        }, 60000);
    },
    beforeDestroy() {
        // Clear refresh function
        clearInterval(this.refreshCycle);
    },
    destroyed() {
        // Clear refresh function
        clearInterval(this.refreshCycle);
    }
}
</script>

<style scoped>
.ado-kiosk__alert {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: .5rem;
}

.ado-kiosk__card {
    border: 0;
    margin-bottom: 220px;
    border-radius: 6px;
    color: #495057;
    background: #fff;
    width: 100%;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .14), 0 3px 1px -2px rgba(0, 0, 0, .2), 0 1px 5px 0 rgba(0, 0, 0, .12);
}

.ado-kiosk__checkin-icon {
    color: #004236;
    text-align: center;
}

.ado-kiosk__checkin-message {
    font-size: 1.25rem;
    font-weight: bold;
    margin-bottom: .5rem;
    text-align: center;
}

.ado-kiosk__credentials {
    z-index: 999;
}

.ado-kiosk__dashboard {
    background: url('../../assets/background/ado-kiosk.jpg') no-repeat center center fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    position: fixed;
    top: 0;
    left: 0;
    min-width: 100%;
    min-height: 100%;
    margin: 0;
}

.ado-kiosk__filter {
    background: rgba(0, 0, 0, .5);
    display: block;
    position: absolute;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
}

.ado-kiosk__logo {
    line-height: 1.2;
    text-align: center;
}

.ado-kiosk__logo img {
    padding-bottom: 20px;
    width: 85px;
}

.ado-kiosk__menu {
    text-align: center;
    z-index: 999;
}

.ado-kiosk__title {
    color: #3C4858;
    font-size: 2rem;
    font-weight: 700;
    line-height: 1.2;
    padding-bottom: 12px;
    text-align: center;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity .5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>